import React from "react";
//#region types
import { CustomerProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import Organization from "./organization";
import Person from "./person";
//#endregion
import { UrlHelper } from "utils/helpers";

const CustomerProfileLink: React.FC<CustomerProps> = (props) => {
  const { id, name, orgNr, onProfileClick } = props;

  const url = UrlHelper.formatPath(`/Customer/${id}`);

  return orgNr ? (
    <Organization id={id} name={name} orgNr={orgNr} href={url} />
  ) : (
    <Person
      id={id}
      name={name}
      hideProfileImage
      href={url}
      onProfileClick={onProfileClick}
      className={props.className}
    />
  );
};

export default CustomerProfileLink;
